import styled from "styled-components";

export const DeviceMetricsChartsWrapper = styled.div`

    display: grid;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    grid-gap: 2px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: minmax(45px, 1fr);
    align-items: stretch;
    justify-items: stretch;
    padding: 2px 0px 0px 0px;
    box-sizing: border-box;
    font-family: -apple-system, "SF UI Text", "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Source Han Sans CN", "Microsoft YaHei", "WenQuanYi Zen Hei", sans-serif;

    &.empty-state {
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(255, 255, 255, 0.6);
        font-size: 14px;
    }
`;

export const PropertyItem = styled.div`
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10px;
        //padding: 5px;
        //border-radius: 4px;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: rgba(255, 255, 255, 0.1);
        }
`;  

export const PropertyName = styled.div`

        //margin-top: 5px;
        margin-bottom: 1px;
        font-size: 12px;
        z-index: 100;
        color: #555555;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
 `;   
 
export const PropertyValue = styled.div`
        font-size: 12px;
        z-index: 100;
        color: #101010;
        font-weight: 500;
        text-align: center;
 `;  

export const PropertyChart = styled.div`
        position: absolute;
        width: calc(100% - 10px);
        height: 33px;
        z-index: 99;
        top: 5px;
        left: 5px;
`; 
 

